import React, { useEffect, useState } from "react";
import { NavLink, Route, Switch, Redirect, useLocation } from "react-router-dom";

const NotABankCustomer = ({ translate }) => {
  const location = useLocation();
  const [showSimaLink, setShowSimaLink] = useState(true);

  useEffect(() => {
    setShowSimaLink(!location.pathname.includes('/juridical'));
  }, [location.pathname]);

  return (
    <>
      <div className="header-sign-section-container-sign">
        <NavLink
          to="/sign-up/not-a-bank-customer/individual"
          className="header-sign-section-container-sign-button m-auto"
          activeClassName="header-sign-section-container-sign-button__active"
        >
          {translate("individual")}
        </NavLink>
        <NavLink
          to="/sign-up/not-a-bank-customer/juridical/asan"
          className="header-sign-section-container-sign-button"
          activeClassName="header-sign-section-container-sign-button__active"
        >
          {translate("juridical")}
        </NavLink>
      </div>
      <div className="header-sign-section-container-sign">
        <NavLink
          to="asan"
          className="header-sign-section-container-sign-type"
          activeClassName="header-sign-section-container-sign-type__active"
        >
          {translate("with Asan İmza")}
        </NavLink>
        {showSimaLink && (
          <NavLink
            to="sima"
            className="header-sign-section-container-sign-type"
            activeClassName="header-sign-section-container-sign-type__active"
          >
            {translate("with SİMA")}
          </NavLink>
        )}
      </div>
    </>
  );
};

export default NotABankCustomer;
